Jelly.Add_Global_Event_Listeners = function ()
{
	// Patch history API so internal pushState/replaceState triggers a URL check.
	// (This helps browsers like Firefox where background-tab timer throttling can prevent polling from running.)
	if (Jelly.Navigation && Jelly.Navigation.Patch_History)
		Jelly.Navigation.Patch_History();

	// Add refresh container listeners.
	Jelly.Interface.Add_Refresh_Container_Listener(function() { 
		$('#Jelly_Wrapper').animate({scrollTop: "0px"}, 300);
	});
	
	// Add document level click, mouse down, mouse move, key down, and scroll handlers...
	
	// TODO: More modern binding 
	if (document.addEventListener)
	{
		document.addEventListener("click", Jelly.Handlers.Document_Click, false);
		document.addEventListener("mousedown", Jelly.Handlers.Document_Mouse_Down, false);
		document.addEventListener("keydown", Jelly.Handlers.Document_Key_Down, false);
		document.addEventListener("mousemove", Jelly.Handlers.Document_Mouse_Move, false);
		document.addEventListener("scroll", Jelly.Handlers.Document_Scroll, false);

		// Keep URL/content in sync on back/forward and on returning to the tab.
		window.addEventListener("popstate", function() {
			if (Jelly.Navigation && Jelly.Navigation.Schedule_Check)
				Jelly.Navigation.Schedule_Check("popstate");
		}, false);

		window.addEventListener("focus", function() {
			if (Jelly.Navigation && Jelly.Navigation.Schedule_Check)
				Jelly.Navigation.Schedule_Check("focus");
		}, false);

		document.addEventListener("visibilitychange", function() {
			if (typeof document.hidden == "undefined" || !document.hidden) {
				if (Jelly.Navigation && Jelly.Navigation.Schedule_Check)
					Jelly.Navigation.Schedule_Check("visibilitychange");
			}
		}, false);
		
		// This one is a mobile safari bugfix/hack to enable :active pseudoclasses
		document.addEventListener("touchstart", function() {}, false);	
		if (Jelly.Show_Context_Menu)
			document.addEventListener("contextmenu", Jelly.Handlers.Document_Context_Click, false);
	}
	else if (document.attachEvent)
	{
		document.attachEvent("click", Jelly.Handlers.Document_Click);
		document.attachEvent("mousedown", Jelly.Handlers.Document_Mouse_Down);
		document.attachEvent("keydown", Jelly.Handlers.Document_Key_Down);			
		document.attachEvent("mousemove", Jelly.Handlers.Document_Mouse_Move);
		document.attachEvent("scroll", Jelly.Handlers.Document_Scroll);
		if (Jelly.Show_Context_Menu)
			document.addEventListener("contextmenu", Jelly.Handlers.Document_Context_Click, false);
	}

	// Close Modals on click
	$(window).on('hashchange', function() {

		if (!window.location.hash) { 
			Jelly.Interface.Close_Top_Window();
			if (Jelly.Interface.Visible_Modal) {
	   		Jelly.Handlers.Call_Handler_For_Target({
	   			Event: 'Dismiss', 
	   			Target: Jelly.Interface.Visible_Modal.Element
	   		});
	   	}
		}
	});
};